<div class="customer-analysis">
  <div class="mt-4">
    <div class="mat-h4-custom">Monthly Revenue</div>
    @if (data && data.revenue) {
      <monthly-revenue-table [data]="data.revenue"></monthly-revenue-table>
      <div class="mt-4">
        <monthly-revenue-chart [data]="data.revenue"></monthly-revenue-chart>
      </div>
    }
  </div>
  <div class="mt-4">
    <div class="mat-h4-custom">Dishonours</div>
    @if (data && data.Dishonours) {
      @if (!isEmpty(data.Dishonours, 'dishonours')) {
        <dishonours-table [data]="data.Dishonours.summary"></dishonours-table>
        <div class="mat-h4-custom sub-title">Dishonour Transactions</div>
        <transaction-table [data]="data.Dishonours.transactions" [type]="'dishonour'"></transaction-table>
      }
      <!--      For testing-->
    @if (isEmpty(data.Dishonours, 'dishonours')) {
      <span class="notes">No dishonour transactions.</span>
    }
  }
</div>
<div class="mt-4">
  <div class="mat-h4-custom">Overdrawn</div>
  @if (data && data.Overdrawn) {
    @if (!isEmpty(data.Overdrawn, 'overdrawn')) {
      <overdrawn-table [data]="data.Overdrawn.summary"></overdrawn-table>
      <div class="mat-h4-custom sub-title">Overdrawn Transactions</div>
      <transaction-table [data]="data.Overdrawn.transactions" [type]="'overdrawn'"></transaction-table>
    }
    <!--      For testing-->
  @if (isEmpty(data.Overdrawn, 'overdrawn')) {
    <span class="notes">No overdrawn transactions.</span>
  }
}
</div>
<div class="mt-4">
  <div class="mat-h4-custom">Non Preferred Lender Summary</div>
  @if (data && data.LenderList) {
    @if (!isEmpty(data.LenderList, 'non-preferred-lender')) {
      <non-preferred-lender-summary [data]="data.LenderList.summary"></non-preferred-lender-summary>
      <div class="mat-h4-custom sub-title">Non Preferred Lender Transactions</div>
      <transaction-table [data]="data.LenderList.transactions" [type]="'non-preferred-lender'"></transaction-table>
    }
    <!--      For testing-->
  @if (isEmpty(data.LenderList, 'non-preferred-lender')) {
    <span class="notes">No relationship with non-preferred lenders.</span>
  }
}
</div>
<div class="mt-4">
  <div class="mat-h4-custom">Monthly Debits / Credits</div>
  @if (data && totalDebitCredit) {
    <monthly-debits-credits-table [data]="totalDebitCredit"></monthly-debits-credits-table>
    <div class="mt-4">
      <monthly-debits-credits-chart [data]="totalDebitCredit"></monthly-debits-credits-chart>
    </div>
  }
</div>
<div class="mt-4">
  <div class="mat-h4-custom">Categories</div>
  @if (data && data.transactionsByCategory) {
    <categories-table 
    [data]="data.transactionsByCategory"
      [accounts]="data.accounts"></categories-table>
  }
</div>
<div class="mt-4">
  <div class="mat-h4-custom">Full Transaction List</div>
  @if (data && data.transactionsByCategory) {
    <full-transaction-list [transactionsByCategory]="data.transactionsByCategory" [accounts]="data.accounts"></full-transaction-list>
  }
</div>
</div>
